import { ligainicial } from "./rutainicial.js";

const ligabase = ligainicial + "2026/Lic/C";

export const licitacionesVigentes = [
    {
        // CONVOCATORIA NUM# 003
        'numConvocatoria' : 'Convocatoria No. 003/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N10-2026.',
        'vigencia' : '9 al 23 de marzo de 2026.',
        'descripcionProcedimiento' : 'Puesta en marcha del canal de interconexión entre la Presa El Yathé y la Presa Vicente Aguirre, en el municipio de Alfajayucan.; ubicada en la localidad y Municipio de Alfajayucan, Estado de Hidalgo',
        'urlAnexos' : `${ ligabase }3/N10/N10.rar`,
        'start' : '2026-03-09',
        'end' : '2026-03-23',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N9-2026.',
        'vigencia' : '9 al 23 de marzo de 2026.',
        'descripcionProcedimiento' : 'Continuación de la construcción de pavimento de concreto hidráulico en acceso a cabecera de Tlahuiltepa.; ubicada en la localidad y Municipio de Tlahuiltepa, Estado de Hidalgo',
        'urlAnexos' : `${ ligabase }3/N9/N9.rar`,
        'start' : '2026-03-09',
        'end' : '2026-03-23',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N8-2026.',
        'vigencia' : '9 al 23 de marzo de 2026.',
        'descripcionProcedimiento' : 'Construcción de techumbre en espacio público multideportivo, en la colonia Parque de Poblamiento, localidad de Col. Parque de Poblamiento, municipio de Huejutla de Reyes.; ubicada en la localidad de Parque de Poblamiento Solidaridad, Municipio de Huejutla de Reyes, Estado de Hidalgo',
        'urlAnexos' : `${ ligabase }3/N8/N8.rar`,
        'start' : '2026-03-09',
        'end' : '2026-03-23',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N7-2026.',
        'vigencia' : '9 al 23 de marzo de 2026.',
        'descripcionProcedimiento' : 'Construcción de línea de conducción de agua potable de la localidad de Ixcuicuila, municipio de Molango de Escamilla.; ubicada en la localidad de Ixcuicuila, Municipio de Molango de Escamilla, Estado de Hidalgo',
        'urlAnexos' : `${ ligabase }3/N7/N7.rar`,
        'start' : '2026-03-09',
        'end' : '2026-03-23',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N6-2026.',
        'vigencia' : '9 al 23 de marzo de 2026.',
        'descripcionProcedimiento' : 'Construcción de puente vehicular en la localidad de Tepetzintla II en el municipio de San Felipe Orizatlán.; ubicada en la localidad de Tepetzintla II, Municipio de San Felipe Orizatlán, Estado de Hidalgo',
        'urlAnexos' : `${ ligabase }3/N6/N6.rar`,
        'start' : '2026-03-09',
        'end' : '2026-03-23',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 002
        'numConvocatoria' : 'Convocatoria No. 002/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N5-2026.',
        'vigencia' : '2 al 13 de marzo de 2026.',
        'descripcionProcedimiento' : 'Pavimentación con concreto hidráulico de Av. Madero (Av. Juárez - Blvd. Río de las Avenidas), en el municipio de Pachuca de Soto.; ubicada en Varias localidades del Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligabase }2/N5/N5.rar`,
        'start' : '2026-03-02',
        'end' : '2026-03-13',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N4-2026.',
        'vigencia' : '2 al 13 de marzo de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de la C.E. Atlapexco - Huejutla de Reyes del Km 8+500 al 18+360, en el municipio de Atlapexco.; ubicada en la localidad y Municipio de Atlapexco, Estado de Hidalgo',
        'urlAnexos' : `${ ligabase }2/N4/N4.rar`,
        'start' : '2026-03-02',
        'end' : '2026-03-13',
        'procedimiento' : 'Licitación Pública',
    },
]